import { Notification, NotificationType } from '@/graphql/appsync-notifications'

export const getToggleColour = (notification: Notification) => {
  if (notification.notificationType === NotificationType.IncidentFlag) {
    return '#CC0000'
  }
  return 'brand.100'
}
